import { useQuery } from "@tanstack/react-query";
import { assetService } from "../../api/assetService";
import { getEmployeeId } from "../../utils/session";
import { cx } from "../../utils/classNames";
import { MY_CLEARANCE_KEY } from "./assetUtils";
import ui from "../../components/ui/ui.module.css";

// Offboarding clearance: whether I still hold company assets.
const ClearanceCard = () => {
  const employeeId = getEmployeeId();

  const query = useQuery({
    queryKey: [MY_CLEARANCE_KEY],
    queryFn: () => assetService.getEmployeeAssets(employeeId),
    enabled: !!employeeId,
  });

  const clearance = query.data?.clearance;
  if (!clearance) return null;

  if (clearance.canClear) {
    return (
      <div className={cx(ui.alert, ui.alertSuccess)}>
        <span>
          <i className="bi bi-check-circle-fill me-2"></i>
          <strong>Clearance:</strong> No company assets to return.
        </span>
      </div>
    );
  }

  return (
    <div className={cx(ui.alert, ui.alertGray, ui.alertColumn)}>
      <span>
        <i className="bi bi-clipboard-check me-2"></i>
        <strong>Clearance:</strong> You still have {clearance.unreturned}{" "}
        asset(s) to return.
      </span>
      {clearance.lost > 0 && (
        <span>{clearance.lost} asset(s) are recorded as lost.</span>
      )}
    </div>
  );
};

export default ClearanceCard;
